import commonConfig from "config/commonConfig";
import enums from "config/enums";
import { getClientDetails } from "utils/common/common.utils";
import localStorageUtils from "utils/local-utils/localstorage.utils";

/**
 * This function sets or retrieves user details from local storage.
 * @param value - The value parameter is a variable that holds the user details that are being passed
 * to the setUser function. It can be either an object containing user details or null/undefined.
 * @returns An empty object is being returned.
 */
export const setUserDetails = (value) => {
  const user = {};
  const { userDetails } = enums.asyncStorage;
  if (!value) {
    value = localStorageUtils.get(userDetails) || {};
  } else {
    localStorageUtils.set(userDetails, value)
  }

  return user;
};

export const setMainClient = (value) => {
  let client = {};
  const dataFound = getClientDetails(commonConfig.clients);

  const { mainClientDetails } = enums.asyncStorage;
  if (!dataFound) {
    client = localStorageUtils.get(mainClientDetails) || {};
  } else {
    return localStorageUtils.set(mainClientDetails, dataFound);
  }

  localStorageUtils.set(mainClientDetails, client);
  return client;
};
